<template>
  <div
    class="platform-mobile-top-bar"
    :style="{ backgroundColor: primaryColor }"
    data-qa="platform-mobile-top-bar"
  >
    <button
      class="platform-mobile-top-bar__profile"
      data-qa="profile-button"
      @click="$emit('profile-click')"
    >
      <VcAvatar
        :imagePath="profileDetails.imagePath"
        :colorId="profileDetails.colorId"
        :name="profileDetails.displayName"
        size="sm"
      />
    </button>

    <div class="platform-mobile-top-bar__actions">
      <button
        class="platform-mobile-top-bar__action-btn"
        data-qa="search-button"
        @click="$emit('search-click')"
      >
        <VcIcon size="16" color="white">$magnify_glass</VcIcon>
      </button>

      <button
        class="platform-mobile-top-bar__action-btn"
        data-qa="notifications-button"
        @click="$emit('notifications-click')"
      >
        <VcBadge :badgeText="notificationsBadge" :offset-y="4" :offset-x="4" size="sm">
          <VcIcon size="20" color="white">$notifications</VcIcon>
        </VcBadge>
      </button>

    </div>
  </div>
</template>

<script>
export default {
  name: 'PlatformMobileTopBar',
  props: {
    primaryColor: {
      type: String,
      default: '',
    },
    profileDetails: {
      type: Object,
      default: () => ({ imagePath: '', colorId: 27, displayName: '' }),
    },
    notificationsBadge: {
      type: [String, Number],
      default: 0,
    },
  },
};
</script>

<style lang="scss" scoped>
.platform-mobile-top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--size-value2) var(--size-value4);
  min-height: 56px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 11;

  &__profile {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: var(--size-value3);
  }

  &__action-btn {
    background: none;
    border: none;
    padding: 0;
    width: 32px;
    height: 32px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    position: relative;
    overflow: visible;
    transition: background-color 0.2s;

    &:hover {
      background-color: rgba(255, 255, 255, 0.15);
    }
  }
}
</style>
